export * from './Main.styled';
